import Vue from 'vue';
import http from '@/http';
import ErrorReporter from '@/services/error-reporter';

const ID_TOKEN_KEY = 'id_token';
const ACCESS_TOKEN_KEY = 'access_token';

const eventHub = new Vue();

export default class AuthService {
  static init() {
    const token = AuthService.getAccessToken();
    const idToken = AuthService.getIdToken();
    http.setToken(token, 'Bearer');
    ErrorReporter.configure({ payload: { person: { id: idToken } } });
  }

  static isLoggedIn() {
    return !!AuthService.getAccessToken(); // && !this.isTokenExpired(this.token);
  }

  static async login({ login, password }) {
    try {
      AuthService.clearTokens();
      const { headers, data } = await http.post('auth/sign_in', { admin_user: { email: login, password } }, { skipInterceptor: true });
      const token = headers.authorization.split(' ')[1];
      AuthService.setAccessToken(token);
      AuthService.setIdToken(data.id);
    } catch (e) {
      throw e;
    }
  }

  static async logout() {
    try {
      await http.delete('auth/sign_out');
    } catch (e) {
      throw e;
    } finally {
      this.clearTokens();
    }
  }

  static clearTokens() {
    AuthService.clearAccessToken();
    AuthService.clearIdToken();
    http.setToken(false);
    ErrorReporter.configure({ payload: { person: {} } });
  }

  static getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }

  static setAccessToken(accessToken) {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    http.setToken(accessToken, 'Bearer');
  }

  static clearAccessToken() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
  }

  static getIdToken() {
    return localStorage.getItem(ID_TOKEN_KEY);
  }

  static setIdToken(idToken) {
    localStorage.setItem(ID_TOKEN_KEY, idToken);
    ErrorReporter.configure({ payload: { person: { id: idToken } } });
  }

  static clearIdToken() {
    localStorage.removeItem(ID_TOKEN_KEY);
  }

  static isUnauthorized(...args) { return http.isUnauthorized(...args); }

  static $emit(...args) { return eventHub.$emit(...args); }
  static $on(...args) { return eventHub.$on(...args); }
}

http.interceptors.response.use(undefined, (error) => {
  if (AuthService.isUnauthorized(error)) {
    const { config = {} } = error.response;
    if (config.skipInterceptor) return Promise.reject(error);
    AuthService.clearTokens();
    AuthService.$emit('unauthorized');
  }
  return Promise.reject(error);
});
